const DraftGreyIcon = ({
  className,
  style,
  onClick,
  fill,
}: {
  className?: string;
  style?: any;
  onClick?: any;
  fill?: any;
}) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      style={style}
      onClick={onClick}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M1 4C1 2.89543 1.89543 2 3 2H21C22.1046 2 23 2.89543 23 4V7C23 8.10457 22.1046 9 21 9H3C1.89543 9 1 8.10457 1 7V4ZM21 4H3V7H21V4Z"
        fill={fill || '#857F8B'}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4 7C4.55228 7 5 7.44772 5 8V19C5 19.2652 5.10536 19.5196 5.29289 19.7071C5.48043 19.8946 5.73478 20 6 20H18C18.2652 20 18.5196 19.8946 18.7071 19.7071C18.8946 19.5196 19 19.2652 19 19V8C19 7.44772 19.4477 7 20 7C20.5523 7 21 7.44772 21 8V19C21 19.7957 20.6839 20.5587 20.1213 21.1213C19.5587 21.6839 18.7957 22 18 22H6C5.20435 22 4.44129 21.6839 3.87868 21.1213C3.31607 20.5587 3 19.7956 3 19V8C3 7.44772 3.44772 7 4 7Z"
        fill={fill || '#857F8B'}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9 12C9 11.4477 9.44772 11 10 11H14C14.5523 11 15 11.4477 15 12C15 12.5523 14.5523 13 14 13H10C9.44772 13 9 12.5523 9 12Z"
        fill={fill || '#857F8B'}
      />
    </svg>
  );
};

export default DraftGreyIcon;
